// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"9986a4ff","480":"2d718d90","598":"203a8157","617":"f594338d","637":"2aa24687","691":"2c131709","829":"e227eff1"}[chunkId] + ".chunk.js";
};